<template>

	<div class="template date" v-show="dataVal.IsShow || dataVal.IsShow == null" v-if="dataVal.MinDate==null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<!-- <input class="input_value" :disabled="dataVal.Disable" :value="dataVal.Value" type="date" :placeholder="dataVal.Placeholder" /> -->
			<div class="input_value">
			<el-date-picker ref="mydate" :disabled="dataVal.Disable"  v-model="dataVal.Value"  align="right" style="width: 100%;"
			 format="yyyy-MM-dd" :change="change(dataVal.Property.Title[0].Text)"
			      value-format="yyyy-MM-dd"
			 type="date" placeholder="选择日期时间"></el-date-picker>
			 </div>
		</div>
	</div>
	<div class="template date" style="height: 58px;" v-show="dataVal.IsShow || dataVal.IsShow == null" v-else-if="dataVal.MinDate!=null">
		<div class="panel_wrap">
			<div class="file-wrap-title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</div>
			<div class="input_value">
				<!-- <el-date-picker :disabled="dataVal.Disable" v-model="dataVal.Value" @focus="forbid" :picker-options="pickerOptions" align="right" style="width: 100%;"
				 type="date" placeholder="选择日期时间"></el-date-picker> -->
				 <el-date-picker ref="mydate" @focus="forbid" v-model="dataVal.Value"  align="right" style="width: 100%;"
				  type="date" placeholder="选择日期时间"></el-date-picker>
				<!-- <el-input placeholder="选择日期时间" :disabled="dataVal.Disable" v-model="dataVal.Value"  align="right" style="width: 100%;"></el-input> -->
			</div>
			<!-- 
			 :readonly="dataVal.Disable"
			 @focus="forbid"
			 -->
		</div>
	</div>


</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {
				pickerOptions: {
					disabledDate: (time) => {
						return time.getTime() <= Date.now();
					}
				}
			}
		},
		mounted() {
		},
		methods: {
			forbid() {
				//禁止软键盘弹出
				document.activeElement.blur();
			},
			change(name){
				this.$emit('child-event',  name, this.dataVal.Value);
			}
		}

	}
</script>

<style scoped lang="less">
	@import '../assets/css/common.css';
</style>
